{
  "Clear search": "Ştergeţi căutarea"
}